import React from "react";

// Processing
export const COUPON_PROCESS_MAX_DAYS_IN_FUTURE = 14;

//TODO: Consolidate other coupon constants here